'use client';

import { useTheme } from '../../../hooks';
import { IconMenu } from '../../icon-menu/IconMenu';
import { Delete, Edit } from '@mui/icons-material';
import { useTranslations } from 'next-intl';

interface Props {
    onEdit: () => void;
    onDelete: () => void;
}

export const CommentEditMenu = ({ onEdit, onDelete }: Props) => {
    const t = useTranslations('details');
    const { colors } = useTheme();

    return (
        <IconMenu
            items={[
                { icon: <Edit />, text: t('edit_answer'), onClick: onEdit },
                {
                    icon: <Delete />,
                    text: t('delete_answer'),
                    onClick: onDelete,
                    color: colors.error
                }
            ]}
            sx={{ display: 'flex', justifyContent: 'flex-end' }}
        />
    );
};
